interface EmptyStateProps {
  title: string
  description?: string
}

export default function EmptyState({ title, description }: EmptyStateProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '48px 0',
        textAlign: 'center',
      }}
    >
      <p
        style={{
          fontSize: 15,
          letterSpacing: '0.15em',
          lineHeight: 1.8,
          color: '#9a9a9a',
        }}
      >
        {title}
      </p>
      {description && (
        <p
          style={{
            fontSize: 13,
            letterSpacing: '0.15em',
            lineHeight: 1.6,
            color: '#9a9a9a',
            marginTop: 8,
          }}
        >
          {description}
        </p>
      )}
    </div>
  )
}
